var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4160_82148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 21,
    width: 24,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 21,
    width: 24,
    height: 8,
    transform: "rotate(90 88 21)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 40C103 35.5817 106.582 32 111 32H208C212.418 32 216 35.5817 216 40V50C216 54.4183 212.418 58 208 58H111C106.582 58 103 54.4183 103 50V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208 36H111C108.791 36 107 37.7909 107 40V50C107 52.2091 108.791 54 111 54H208C210.209 54 212 52.2091 212 50V40C212 37.7909 210.209 36 208 36ZM111 32C106.582 32 103 35.5817 103 40V50C103 54.4183 106.582 58 111 58H208C212.418 58 216 54.4183 216 50V40C216 35.5817 212.418 32 208 32H111Z",
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 74C103 69.5817 106.582 66 111 66H208C212.418 66 216 69.5817 216 74V84C216 88.4183 212.418 92 208 92H111C106.582 92 103 88.4183 103 84V74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208 70H111C108.791 70 107 71.7909 107 74V84C107 86.2091 108.791 88 111 88H208C210.209 88 212 86.2091 212 84V74C212 71.7909 210.209 70 208 70ZM111 66C106.582 66 103 69.5817 103 74V84C103 88.4183 106.582 92 111 92H208C212.418 92 216 88.4183 216 84V74C216 69.5817 212.418 66 208 66H111Z",
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 100,
    width: 61,
    height: 26,
    rx: 4,
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 21,
    width: 24,
    height: 8,
    transform: "rotate(90 240 21)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 29,
    width: 24,
    height: 8,
    transform: "rotate(-180 240 29)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 134,
    width: 24,
    height: 8,
    transform: "rotate(-180 240 134)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 134,
    width: 24,
    height: 8,
    transform: "rotate(-90 232 134)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 134,
    width: 24,
    height: 8,
    transform: "rotate(-90 80 134)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 126,
    width: 24,
    height: 8,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#B4DDEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4160_82148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 117,
    fill: "white",
    transform: "translate(80 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.f101281160855a70388f858ff4e8c7ef.svg";
export { ForwardRef as ReactComponent };